import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { Padding } from "@mui/icons-material";

const formatLabel = (key) => {
  return key
    ?.replace(/([a-z])([A-Z])/g, "$1 $2")
    ?.replace(/_/g, " ")
    ?.replace(/\b\w/g, (char) => char.toUpperCase());
};

const parseListenersDynamically = (fieldData) => {
  let parsed = fieldData;

  try {
    parsed = typeof fieldData === "string" ? JSON.parse(fieldData) : fieldData;
  } catch {
    return [];
  }

  if (!Array.isArray(parsed)) return [];

  return parsed.map((listener, listenerIndex) => {
    const { TargetGroupCollection, ...listenerFields } = listener;

    return {
      title: `Listener ${listenerIndex + 1}`,
      fields: Object.entries(listenerFields || {}),
      targetGroups: Array.isArray(TargetGroupCollection)
        ? TargetGroupCollection.map((tg, tgIndex) => ({
            title: `Target Group ${tgIndex + 1}`,
            fields: Object.entries(tg || {}),
          }))
        : [],
    };
  });
};

const labelSx = {
  mr: 2,
  mb: 1,
  textTransform: "capitalize",
  color: "#888",
};

const valueSx = {
  color: "#1976d2",
  mb: 1,
  wordBreak: "break-word",
};

const rowSx = {
  display: "flex",
  justifyContent: "space-between",
  mb:1
};
const tablefromsx = {
  display: "grid",
  gridTemplateColumns: "260px 1fr",
  alignItems: "center",
  py: 1,
  // PaddingTop:"14px",
  // mt:0.2,
  
  borderBottom: "1px solid #e0e0e0",
  
}
 

const DynamicListeners = ({ fieldData , tablefrom }) => {
  const listeners = parseListenersDynamically(fieldData);

  if (!listeners.length) {
    return (
      <Typography variant="body2" sx={{ color: "#1976d2" }}>
        N/A
      </Typography>
    );
  }
const displayValue = (val) => {
  if (val === null || val === undefined || val === "") return "N/A";
  if (typeof val === "boolean") return String(val);
  return val;
};
  return (
    <Box sx={{ width: "100%" }}>
      {/* <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", mb: 1 }}
      >
        Listeners
      </Typography> */}

      {listeners.map((listener, listenerIndex) => (
        <Box key={listenerIndex} sx={{ mb: 2 }}>
          <Typography
            variant="body2"
            sx={{ fontWeight: "bold", mb: 1 ,mt:2}}
          >
            {listener.title}
          </Typography>

          {listener.fields.map(([key, value], idx) => (
            <Box key={`${listenerIndex}-${key}-${idx}`}  sx={tablefrom ? tablefromsx : rowSx}>
              <Box sx={{ width: "48%" }}>
                <Typography variant="body2" sx={labelSx}>
                  {formatLabel(key)}:
                </Typography>
              </Box>
              <Box sx={{ width: "48%" }}>
                <Typography variant="body2" sx={valueSx}>
                
                    {displayValue(value)}
                </Typography>
              </Box>
            </Box>
          ))}

          {listener.targetGroups.length > 0 && (
            <Box sx={{ mb: 2 }}>
              {/* <Typography
                variant="body2"
                sx={{ fontWeight: "bold", mb: 1 }}
              >
                Target Groups
              </Typography> */}

              {listener.targetGroups.map((tg, tgIndex) => (
                <Box key={tgIndex}
                sx={{ mt: 2 }} >
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "bold", mb: 1,mt:2 }}
                  >
                    {tg.title}
                  </Typography>

                  {tg.fields.map(([tgKey, tgValue], tgFieldIndex) => (
                    <Box key={`${tgIndex}-${tgKey}-${tgFieldIndex}`} sx={tablefrom ? tablefromsx : rowSx} >
                      <Box sx={{ width: "48%" }}>
                        <Typography variant="body2" sx={labelSx}>
                          {formatLabel(tgKey)}:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "48%" }}>
                        <Typography variant="body2" sx={valueSx}>
                          
                           {displayValue(tgValue)}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              ))}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

DynamicListeners.propTypes = {
  fieldData: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default DynamicListeners;